<script setup>
import { useAttrs } from 'vue'
const attrs = useAttrs()

defineProps({
  icon: {
    type: String,
    default: 'bi-box-seam'
  },
  label: String,
  shadow: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <!-- Root receives forwarded class! -->
  <div class="group" v-bind="attrs">
    <div
        class="inline-flex items-center rounded-lg py-1 px-3
        group-[.success]:bg-success/10 group-[.success]:text-success
        group-[.accent]:bg-accent/10 group-[.accent]:text-accent
        group-[.warning]:bg-warning/10 group-[.warning]:text-warning
        group-[.info]:bg-info/10 group-[.info]:text-info
        group-[.primary]:bg-primary/10 group-[.primary]:text-primary
        group-[.error]:bg-error/10 group-[.error]:text-error
        group-[.neutral]:bg-neutral/10 group-[.neutral]:text-neutral
        group-[.light]:bg-light/10 group-[.light]:light
        group-[.blue]:bg-blue-100 group-[.blue]:text-blue-400
        group-[.gray]:bg-gray-100 group-[.gray]:text-gray-400
        group-[.yellow]:bg-yellow-100 group-[.yellow]:text-yellow-500
        group-[.orange]:bg-orange-100 group-[.orange]:text-orange-500
        group-[.green]:bg-green-100 group-[.green]:text-green-600
        group-[.red]:bg-red-100 group-[.red]:text-red-400
        group-[.white]:bg-white group-[.white]:text-neutral-800"
        :class="{ shadow }"
    >
      <i class="bi text-3xl group-[.sm]:text-lg" :class="icon"/>
      <span v-if="label" class="font-normal text-xs ms-4">{{ label }}</span>
    </div>
  </div>
</template>